import React from 'react';
import { StyleSheet, View } from 'react-native';

export const CurrencyCardOverlay = () => {
    return <View style={[StyleSheet.absoluteFill]} />;
};
